export {CanvasComponent as CanvasPanel} from './canvas.component';



// WEBPACK FOOTER //
// ./src/app/canvas/index.ts